interface IIconInfoProps {
  className?: string;
}

export const IconNotification = ({ className }: IIconInfoProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} width="19" height="22" viewBox="0 0 19 22">
    <rect x="0.101562" width="18" height="22" fill="url(#pattern0_2734_21434)" />
    <defs>
      <pattern id="pattern0_2734_21434" patternContentUnits="objectBoundingBox" width="1" height="1">
        <use xlinkHref="#image0_2734_21434" transform="matrix(0.0611111 0 0 0.05 -0.0194444 0)" />
      </pattern>
      <image
        id="image0_2734_21434"
        width="17"
        height="20"
        preserveAspectRatio="none"
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAUCAYAAABroNZJAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGfSURBVDhP3ZO/S8NAHMWflpNCEZyC2KmCRSFLJwdB0MGK0qWSpSgI4iYFUQepoIs4WCj4D1To4qBTxR+DHbSLDhZ1y6JIA+3hILiIsZ7N3Rlsmoh19DMk7/sC7765+x7YD1RvTtjB0R2rvkvDgzbrARfMqx3Mposw65oML2F3YRBEfGqiXb4bqZkoGwYPsDAfDZS/CheaOnku5bCVyeP+VRo2BKHJZaxOR9Dlk5akIYQer2Exq4sO/EFEhlQoHSbo7QVKhmiF9M8hsx6F8j3ICuHQE5ZKaEzTNDa/fcbKjs0sF9Jsvv5N0xIsdVqVrsDeE+M8D91arDOK5MIogo6WgyNJJMcCdWVCPyzCEDZHhlBcX1KulIlxqH4uHRCo0RgUS1YucV3hJscOoQ9Cqb1BIdzoCUHl4h5UrMlpOmLi+I0GfMR1VtznpEX+Ywg93kOBl7+nsH8KWhO6rXqUYvaot8jXFfD1v3Vv6NJslY+nEmoDWvMt/gseITpyc2vIv8gSAcQ2s5jpk6UDj9MJI74SR7izPp8kgPDUKuIeAQDwCZYv7yNSR5CDAAAAAElFTkSuQmCC"
      />
    </defs>
  </svg>
);
